import { render, staticRenderFns } from "./DepartmentsFinance.vue?vue&type=template&id=9ef6fc62"
import script from "./DepartmentsFinance.vue?vue&type=script&lang=js"
export * from "./DepartmentsFinance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports